export const en = {
  paper: {
    pagination: "Page {current} of {count}",
    printedOn: "Printed on {date} at {time}",
  },
};
